import styled from 'styled-components';
import {
  padding,
  alignItems,
  grid,
  AlignItemsProps,
  PaddingProps,
  GridProps,
} from 'styled-system';

export const Container = styled.div<PaddingProps & AlignItemsProps & GridProps>`
  display: flex;
  flex-wrap: wrap;
  ${padding};
  ${alignItems};
  ${grid};
`;
